import React from 'react';

const InsightCard = React.memo(({ item, impactColor, impactIcon }) => (
  <div className={`p-4 rounded-lg border ${impactColor(item.impact)}`}>
    <div className="flex items-start space-x-3">
      <span className="text-xl">{impactIcon(item.impact)}</span>
      <div className="flex-1">
        <h4 className="font-semibold text-gray-900">{item.title}</h4>
        <p className="text-sm text-gray-700 mt-1">{item.description}</p>
        <div className="flex items-center space-x-4 mt-2 text-sm">
          <span className="font-medium">Your Score: {item.metric}</span>
          <span className="text-gray-600">Average: {item.benchmark}</span>
        </div>
        <p className="text-sm font-medium mt-2">{item.recommendation}</p>
        {item.actionItems && (
          <div className="mt-3">
            <p className="text-sm font-medium text-gray-700 mb-2">Action Items:</p>
            <ul className="text-sm text-gray-600 space-y-1">
              {item.actionItems.map((action, idx) => (
                <li key={idx} className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>{action}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  </div>
));

export default InsightCard;
